/**
 * 等待 plus 对象准备就绪
 * @param {Function} callback - plus 准备就绪后的回调函数
 * @param {Object} context - 回调函数的执行上下文（可选）
 */
export function onPlusReady(callback, context = null) {
  if (window.plus) {
    callback.call(context)
  } else {
    document.addEventListener('plusready', function () {
      callback.call(context)
    }, false)
  }
}

/**
 * Promise 版本的 plusReady，支持 async/await
 * @returns {Promise}
 */
export function plusReady() {
  return new Promise((resolve) => {
    if (window.plus) {
      resolve()
    } else {
      document.addEventListener('plusready', () => {
        resolve()
      }, false)
    }
  })
}
